import React, { Component } from "react";
import { Button, Modal, Select, Descriptions, Input  } from "antd";
import { deletedCode } from "../../lib/util/codeUtil";
import SelectBox from "../common/SelectBox";
import { httpUrl, httpPost, httpGet } from "../../api/httpClient";

const Ditems = Descriptions.Item;
class NoticeDetail extends Component{
    state = {};  

    onCancel = () => {
        this.props.onCancel();
    };

    componentDidMount() {}


    render() {
        const { visible, data, onClose} = this.props;
    
        return (
            <Modal
                visible={visible}
                title={"상세보기"}
                onCancel={onClose}        
                okText={data.chargeType ? "수정" : "등록"}
                cancelText="확인"
                footer={null}
                style={{ minWidth: "800px"}}
            >
                <Descriptions
                    bordered
                    column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}
                >            
                    <Ditems
                        label="제목"
                        span={2}
                        labelStyle={{textAlign: "center", width:150}}
                    >
                        {data.title}
                    </Ditems>
                    <Ditems
                        label="내용"
                        span={2}
                        labelStyle={{textAlign: "center", width:150, height:250}}>
                        {data.content}
                    </Ditems>            
                </Descriptions>
            </Modal>
        );
    }
}
   


export default NoticeDetail;